module.exports = __webpack_public_path__ + "img/14-1.6e72331d.png";